/*
 * Copyright 2022-2026 NXGN Management, LLC. All Rights Reserved.
 */

export enum VendorTypes {
  ELEMENT = "Element",
  PAYPAL = "PayPal",
  INSTAMED = "InstaMed",
  QBPay = "QBPay",
  QBMS = "QBMS",
  GLOBALPAYMENTS = "Global Payments"
}
